// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rewardsPage {
    display: flex;
    justify-content: center;
    padding: 24px 16px 64px;
    background: #0f1115; /* dark bg to match app theme */
    min-height: 100%;
}

.rewardsContainer {
    width: 100%;
    max-width: 720px;
}

.rewardsHeader {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
}

.rewardsTrophy {
    width: 56px;
    height: 56px;
    border-radius: 16px;
    background: rgba(0, 213, 185, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
}

.trophyIcon {
    color: #00d5b9;
    font-size: 28px;
}

.rewardsTitleBlock {
    display: flex;
    flex-direction: column;
}

.rewardsTitle {
    margin: 0;
    font-size: 24px;
    color: #ffffff;
}

.rewardsSubtitle {
    margin: 2px 0 0 0;
    color: #b5bcc5;
    font-size: 14px;
}

.pointsCard {
    margin: 16px 0 20px;
    background: #171a21;
    border-radius: 18px;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgba(255, 255, 255, 0.06);
}

.pointsContent {
    display: flex;
    flex-direction: column;
}

.pointsLabel {
    color: #b5bcc5;
    font-size: 14px;
}

.pointsValue {
    color: #4be3cf;
    font-size: 40px;
    font-weight: 700;
    line-height: 1.1;
}

.pointsBadge {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: rgba(75, 227, 207, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
}

.pointsBadgeIcon {
    color: #4be3cf;
}

.sectionCard {
    background: #171a21;
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    padding: 16px;
    margin-top: 16px;
}

.sectionHeader {
    color: #ffffff;
    font-weight: 600;
    margin-bottom: 8px;
}

.completedList {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.completedItem {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #111319;
    border-radius: 14px;
    padding: 12px;
}

.completedIconWrap {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: rgba(75, 227, 207, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
}

.completedIcon {
    color: #4be3cf;
}

.completedText {
    flex: 1 1;
}

.completedTitle {
    color: #e6eaef;
    font-size: 15px;
}

.pointsTag {
    color: #4be3cf;
    font-weight: 700;
}

.emptyState {
    color: #9aa3ad;
    background: #111319;
    border-radius: 12px;
    padding: 12px;
    text-align: center;
}

.clickable {
    cursor: pointer;
    transition: transform 120ms ease, background 120ms ease;
}

.clickable:hover {
    transform: translateY(-1px);
    background: #1a1e26;
}

.howToEarn {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.howLeft {
    display: flex;
    align-items: center;
    gap: 12px;
}

.howIcon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: rgba(75, 227, 207, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
}

.howIconSvg {
    color: #4be3cf;
}

.howText {
    display: flex;
    flex-direction: column;
}

.howTitle {
    color: #e6eaef;
    font-weight: 600;
}

.howSubtitle {
    color: #9aa3ad;
    font-size: 13px;
}

.chevronIcon {
    color: #64707d;
    transition: transform 160ms ease;
}

.chevronOpen {
    transform: rotate(90deg);
}

.howContent {
    margin-top: 12px;
    background: #111319;
    border-radius: 12px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.howRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #e6eaef;
}

.howRowPoints {
    color: #4be3cf;
    font-weight: 700;
}

.howHint {
    color: #9aa3ad;
    font-size: 13px;
}

/* Leaderboard */
.leaderboardPodium {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-top: 8px;
    margin-bottom: 8px;
}

.podiumItem {
    background: #111319;
    border-radius: 14px;
    padding: 12px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.podiumItem.center {
    outline: 2px solid rgba(249, 200, 86, 0.3);
}

.avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: rgba(75, 227, 207, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.avatar.crown::after {
    content: "\\1F451"; /* crown emoji */
    position: absolute;
    top: -10px;
    font-size: 18px;
}

.avatarInitial {
    color: #4be3cf;
    font-weight: 700;
}

.podiumName {
    color: #e6eaef;
    font-size: 14px;
    margin-top: 6px;
    text-align: center;
}

.podiumPoints {
    color: #4be3cf;
    font-weight: 700;
    margin-top: 2px;
}

.leaderboardList {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 6px;
}

.leaderItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #111319;
    border-radius: 12px;
    padding: 10px 12px;
}

.leaderLeft {
    display: flex;
    align-items: center;
    gap: 10px;
}

.rank {
    color: #9aa3ad;
    width: 28px;
}

.smallAvatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(75, 227, 207, 0.12);
    color: #4be3cf;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
}

.leaderName {
    color: #e6eaef;
}

.leaderPoints {
    color: #4be3cf;
    font-weight: 700;
}

.userRankHint {
    margin-top: 10px;
    text-align: center;
    color: #b5bcc5;
}

@media (min-width: 768px) {
    .pointsValue {
        font-size: 48px;
    }
}


`, "",{"version":3,"sources":["webpack://./src/Components/Rewards/Rewards.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB,EAAE,+BAA+B;IACpD,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB,EAAE,gBAAgB;IACnC,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".rewardsPage {\n    display: flex;\n    justify-content: center;\n    padding: 24px 16px 64px;\n    background: #0f1115; /* dark bg to match app theme */\n    min-height: 100%;\n}\n\n.rewardsContainer {\n    width: 100%;\n    max-width: 720px;\n}\n\n.rewardsHeader {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.rewardsTrophy {\n    width: 56px;\n    height: 56px;\n    border-radius: 16px;\n    background: rgba(0, 213, 185, 0.12);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.trophyIcon {\n    color: #00d5b9;\n    font-size: 28px;\n}\n\n.rewardsTitleBlock {\n    display: flex;\n    flex-direction: column;\n}\n\n.rewardsTitle {\n    margin: 0;\n    font-size: 24px;\n    color: #ffffff;\n}\n\n.rewardsSubtitle {\n    margin: 2px 0 0 0;\n    color: #b5bcc5;\n    font-size: 14px;\n}\n\n.pointsCard {\n    margin: 16px 0 20px;\n    background: #171a21;\n    border-radius: 18px;\n    padding: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.pointsContent {\n    display: flex;\n    flex-direction: column;\n}\n\n.pointsLabel {\n    color: #b5bcc5;\n    font-size: 14px;\n}\n\n.pointsValue {\n    color: #4be3cf;\n    font-size: 40px;\n    font-weight: 700;\n    line-height: 1.1;\n}\n\n.pointsBadge {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    background: rgba(75, 227, 207, 0.12);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.pointsBadgeIcon {\n    color: #4be3cf;\n}\n\n.sectionCard {\n    background: #171a21;\n    border-radius: 18px;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    padding: 16px;\n    margin-top: 16px;\n}\n\n.sectionHeader {\n    color: #ffffff;\n    font-weight: 600;\n    margin-bottom: 8px;\n}\n\n.completedList {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.completedItem {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    background: #111319;\n    border-radius: 14px;\n    padding: 12px;\n}\n\n.completedIconWrap {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    background: rgba(75, 227, 207, 0.12);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.completedIcon {\n    color: #4be3cf;\n}\n\n.completedText {\n    flex: 1;\n}\n\n.completedTitle {\n    color: #e6eaef;\n    font-size: 15px;\n}\n\n.pointsTag {\n    color: #4be3cf;\n    font-weight: 700;\n}\n\n.emptyState {\n    color: #9aa3ad;\n    background: #111319;\n    border-radius: 12px;\n    padding: 12px;\n    text-align: center;\n}\n\n.clickable {\n    cursor: pointer;\n    transition: transform 120ms ease, background 120ms ease;\n}\n\n.clickable:hover {\n    transform: translateY(-1px);\n    background: #1a1e26;\n}\n\n.howToEarn {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.howLeft {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.howIcon {\n    width: 40px;\n    height: 40px;\n    border-radius: 12px;\n    background: rgba(75, 227, 207, 0.12);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.howIconSvg {\n    color: #4be3cf;\n}\n\n.howText {\n    display: flex;\n    flex-direction: column;\n}\n\n.howTitle {\n    color: #e6eaef;\n    font-weight: 600;\n}\n\n.howSubtitle {\n    color: #9aa3ad;\n    font-size: 13px;\n}\n\n.chevronIcon {\n    color: #64707d;\n    transition: transform 160ms ease;\n}\n\n.chevronOpen {\n    transform: rotate(90deg);\n}\n\n.howContent {\n    margin-top: 12px;\n    background: #111319;\n    border-radius: 12px;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.howRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: #e6eaef;\n}\n\n.howRowPoints {\n    color: #4be3cf;\n    font-weight: 700;\n}\n\n.howHint {\n    color: #9aa3ad;\n    font-size: 13px;\n}\n\n/* Leaderboard */\n.leaderboardPodium {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n\n.podiumItem {\n    background: #111319;\n    border-radius: 14px;\n    padding: 12px 8px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.podiumItem.center {\n    outline: 2px solid rgba(249, 200, 86, 0.3);\n}\n\n.avatar {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    background: rgba(75, 227, 207, 0.12);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.avatar.crown::after {\n    content: \"\\1F451\"; /* crown emoji */\n    position: absolute;\n    top: -10px;\n    font-size: 18px;\n}\n\n.avatarInitial {\n    color: #4be3cf;\n    font-weight: 700;\n}\n\n.podiumName {\n    color: #e6eaef;\n    font-size: 14px;\n    margin-top: 6px;\n    text-align: center;\n}\n\n.podiumPoints {\n    color: #4be3cf;\n    font-weight: 700;\n    margin-top: 2px;\n}\n\n.leaderboardList {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 6px;\n}\n\n.leaderItem {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #111319;\n    border-radius: 12px;\n    padding: 10px 12px;\n}\n\n.leaderLeft {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.rank {\n    color: #9aa3ad;\n    width: 28px;\n}\n\n.smallAvatar {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: rgba(75, 227, 207, 0.12);\n    color: #4be3cf;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n}\n\n.leaderName {\n    color: #e6eaef;\n}\n\n.leaderPoints {\n    color: #4be3cf;\n    font-weight: 700;\n}\n\n.userRankHint {\n    margin-top: 10px;\n    text-align: center;\n    color: #b5bcc5;\n}\n\n@media (min-width: 768px) {\n    .pointsValue {\n        font-size: 48px;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
